import { render, staticRenderFns } from "./MypageReviews.vue?vue&type=template&id=a3805c40&"
import script from "./MypageReviews.vue?vue&type=script&lang=ts&"
export * from "./MypageReviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports